import { Checkbox, Col, Collapse, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { hasValueInList } from '../../../../helpers/array';
import { LabelCheckbox, SubGrupo, Title } from '../styles';

const { Panel } = Collapse;

export default function PreferenciasPlataforma({
  permissoesExistentes,
  selectedPermissions,
  onSelectPermission,
  isDisabled,
}) {
  return (
    <>
      {Object.keys(permissoesExistentes).map(grupo => (
        <Col className="padding" span={24} key={grupo}>
          <Collapse
            bordered={false}
            defaultActiveKey={isDisabled ? ['1', '2'] : []}
          >
            <Panel header={grupo} key="1">
              <SubGrupo>
                {Object.keys(permissoesExistentes[grupo]).map(subGrupo => (
                  <Col className="paddingSubGrupo" key={subGrupo} span={24}>
                    <Row>
                      <Col span={24}>
                        <Title>{subGrupo}</Title>
                      </Col>
                      {permissoesExistentes[grupo][subGrupo].map(
                        ({ id, name }) => (
                          <Col xs={24} sm={9} md={9} lg={8} xl={6} key={id}>
                            <Checkbox
                              value={id}
                              checked={hasValueInList(
                                selectedPermissions,
                                'id',
                                id
                              )}
                              onChange={() => onSelectPermission(id)}
                              disabled={isDisabled}
                            >
                              <LabelCheckbox>{name}</LabelCheckbox>
                            </Checkbox>
                          </Col>
                        )
                      )}
                    </Row>
                  </Col>
                ))}
              </SubGrupo>
            </Panel>
          </Collapse>
        </Col>
      ))}
    </>
  );
}

PreferenciasPlataforma.propTypes = {
  permissoesExistentes: PropTypes.instanceOf(Object).isRequired,
  selectedPermissions: PropTypes.instanceOf(Array).isRequired,
  onSelectPermission: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

PreferenciasPlataforma.defaultProps = {
  isDisabled: false,
};
